import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { getDefaultOnBoardingFlowKey } from 'src/api/onBoardingFlow';
import { UserType } from 'src/pages/types';
import { getUserOnBoardingFlowKeySelector } from 'src/redux/onBoardingFlow/selector';
import { userSelector } from 'src/redux/user/selector';
import { PublicRoutes } from 'src/routes/navigation';

export const useUser = () => {
  const currentUser = useSelector(userSelector);
  const history = useHistory();
  const onboardingKey = useSelector(getUserOnBoardingFlowKeySelector);

  const _isNeedRedirectToOnboarding = useCallback(
    (forceUser?: UserType) => {
      const user = forceUser ?? currentUser;
      if (
        !user ||
        user.onBoardingAnswers ||
        Object.keys(user.onBoardingAnswers || {}).length ||
        user.is_viewed_specialist_list
      ) {
        return false;
      }
      return true;
    },
    [currentUser]
  );

  const redirectToOnboarding = useCallback(
    async (forceUser?: UserType): Promise<boolean> => {
      let flowId = onboardingKey;
      const user = forceUser ?? currentUser;
      if (!_isNeedRedirectToOnboarding(forceUser)) return false;

      if (!flowId) {
        const { data: flowData } = await getDefaultOnBoardingFlowKey(user?.app_lang ?? 'uk');
        flowId = flowData.onboarding_key;
      }

      history.push(PublicRoutes.ON_BOARDING_FLOW.replace(':flowId', flowId));
      return true;
    },
    [currentUser, history, onboardingKey]
  );

  const isNeedRedirectToOnboarding = useMemo(() => _isNeedRedirectToOnboarding(), [_isNeedRedirectToOnboarding]);

  return {
    redirectToOnboarding,
    isNeedRedirectToOnboarding,
  };
};
